module.exports = __webpack_public_path__ + "img/hr-rock-huge-17.526c5092.png";